import {Component, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {getAppThemeName} from 'src/app/core/functions/common.function';
import {CommonService} from '../../services/common.service';
import {DBIconModule, DBMenuModule} from "@db/db-core";
import {CommonModule} from "@angular/common";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'language-menu',
  templateUrl: './language-menu.component.html',
  imports: [
    DBMenuModule,
    DBIconModule,
    CommonModule,
  ],
  standalone: true,
  styleUrls: ['./language-menu.component.scss']
})
export class LanguageMenuComponent implements OnInit, OnDestroy {
  public getThemeName?: string;
  public languagesList: Array<string> = [];
  public activeLanguage: string | undefined;
  public langSelectDisabled: boolean = true;
  private _color = '#fff'
  public _isMenuOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _iconOnly: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private outsideClickListener!: () => void;

  @Input()
  set color(color: string) {
    this._color = color;
  }

  @Input()
  set iconOnly(value: boolean) {
    this._iconOnly.next(value);
  }

  constructor(
    private translate: TranslateService,
    private appService: CommonService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
    this.getThemeName = getAppThemeName();
    this.appService._languageData.subscribe(data => {
      this.translate.use(data.activeLang);
    });
    this.setLangInfo();
    this.outsideClickListener = this.renderer.listen('window', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      const menu = document.getElementsByClassName('db-overlay is-visible')[0] as HTMLElement;
      if (!menu) {
        return;
      }
      // If the menu contains the target, keep the current state; otherwise, toggle the menu open state.
      if (menu.contains(target)) {
        this.setMenuIcon(this._isMenuOpen.value);
      } else {
        this.setMenuIcon(!this._isMenuOpen.value);
      }
    });
  }

  ngOnDestroy() {
    if (this.outsideClickListener) {
      this.outsideClickListener();
    }
    this._isMenuOpen.unsubscribe();
  }

  setLangInfo() {
    this.appService._languageData.subscribe(data => {
      this.activeLanguage = data.activeLang;
      this.languagesList = data.langList;
      this.translate.use(data.activeLang);
      sessionStorage.setItem('lang', data.activeLang);
    });
    this.appService._langSelectionEnabled.subscribe(isEnabled => this.langSelectDisabled = !isEnabled);
  }

  getLanguageOptions() {
    return this.languagesList;
  }

  setActiveLanguage(event: any) {
    const lang = event.target.innerText.toLowerCase();
    sessionStorage.setItem('lang', lang);
    this.appService.setActiveLang(this.languagesList, lang);
    this.setMenuIcon(!this._isMenuOpen.value);
  }

  setMenuIcon(value: boolean) {
    this._isMenuOpen.next(value);
  }

  get isMenuOpen() {
    return this._isMenuOpen.value;
  }

  get color() {
    return this._color;
  }

  get iconOnly() {
    return this._iconOnly.value;
  }

  protected readonly getAppThemeName = getAppThemeName;
  protected readonly sessionStorage = sessionStorage;
  protected readonly window = window;
}
